import { useEffect, useState } from "react";

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const delayer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(delayer);
  }, [value, delay]);

  return debouncedValue;
};
